function getButtonLabel(node) {
  if (!(node instanceof HTMLElement)) {
    return '';
  }

  const explicitText = node.dataset?.ariaLabelText || '';
  if (explicitText.trim()) {
    return explicitText.trim();
  }

  return (node.textContent || '').replace(/\s+/g, ' ').trim();
}

export default function initButtonAria(root = document) {
  if (!root || typeof root.querySelectorAll !== 'function') {
    return;
  }

  root.querySelectorAll('a.button, button.button, a[class*="button--"], button[class*="button--"]').forEach((node) => {
    if (node.hasAttribute('aria-label')) {
      return;
    }

    const label = getButtonLabel(node);
    if (!label) {
      return;
    }

    node.setAttribute('aria-label', label);
  });
}
